export const BUSINESS_DOCUMENT_TYPE_ENUM = {
    QUOTE: { value: 'quote', label: 'Devis' },
    INVOICE: { value: 'invoice', label: 'Facture' },
    DEPOSIT: { value: 'deposit', label: 'Acompte' },
    CREDIT_NOTE: { value: 'creditNote', label: 'Avoir' },
};